import { useContext } from 'react';
import { rootStoreContext } from './configureStore';
export function useStore(fn) {
  const store = useContext(rootStoreContext);
  if (fn) {
    return fn(store);
  }
  return store;
}